import {RESOLVE_CUSTOM_SETTINGS_FROM_URL} from '.';
import 'url-search-params-polyfill';

const resolveCustomSettingsFromUrl = ({dispatch}) => {
  let queryParams = new URLSearchParams(document.location.search.substring(1));
  let customSettingsBase64 = queryParams.get("c");

  if(customSettingsBase64) {
    let customSettingsQueryParams = atob(customSettingsBase64);
    customSettingsQueryParams = customSettingsQueryParams.split("&");

    let customSettings = {};

    for(let i = 0; i <  customSettingsQueryParams.length; i++) {
      const queryParam = customSettingsQueryParams[i];
      let queryParamPair = queryParam.split('=');
      customSettings[queryParamPair[0]] = queryParamPair[1];
    }

    dispatch({
      type: RESOLVE_CUSTOM_SETTINGS_FROM_URL,
      customSettings: customSettings
    });
  }
};

export default resolveCustomSettingsFromUrl;
